module.exports = __webpack_public_path__ + "img/baidupp@2X.a9666c7c.png";